module.exports = __webpack_public_path__ + "static/3996043_orig-c4e018aa81765af10b0bbe4268e4ed93.jpg";